import {getStore} from "trim-redux";

/*export const defaultVariabls = {
        url: "https://epanjere.com/api",
        uploads: "https://epanjere.com/uploads",
        React:"https://panel.epanjere.com",
        website: "https://epanjere.com",
        developer: "https://rayanita.com",
};*/

/*export const defaultVariabls = {
       url: "http://localhost:8000/api",
        uploads: "http://localhost:8000/uploads",
        React:"http://localhost:3000",
        website: "http://127.0.0.1:8000",
        developer: "https://rayanita.com",
};*/

export let defaultVariabls = {
    url: "https://epanjere.com/api",
    uploads: "https://epanjere.com/uploads",
    React:"https://panel.epanjere.com",
    website: "https://epanjere.com",
    developer: "https://rayanita.com",
};

export function generateURLs() {
    let isAuth = getStore('isAuth');
    defaultVariabls = {
        url: "https://epanjere.com/api",
        uploads: "https://epanjere.com/uploads",
        React:"https://panel.epanjere.com",
        website: "https://epanjere.com",
        developer: "https://rayanita.com",
    }
}
